import React, { Component } from 'react'
import autobind from 'autobind-decorator'
import PropTypes from 'prop-types'

import API from '../api'

import Close from 'react-icons/fa/times-circle'
import Caret from 'react-icons/fa/angle-right'

@autobind
class ResourceHeader extends Component {
  constructor (props) {
    super(props)
    this.state = {resource: {}}
  }

  componentWillMount () {
    this.getResource()
  }

  getResource () {
    return API.get(`/v3/teaching_resources/${this.props.resourceId}?include=teaching_resource.title,teaching_resource.source_url,teaching_resource.source_type,teaching_resource.external_id`)
      .then(({data}) => {
        this.setState({resource: data.teaching_resource})
      })
  }

  render () {
    var resource = <header className='ResourceHeader'>
      <div className='ResourceHeader__intro'>
        {this.state.resource.source_type && <div className='resourceProvider'>
          {/*<div className={`resourceProvider__icon resource__source__icon--${this.state.resource.source_type_key}`} />*/}
          <div className='resourceProvider__name'>{this.state.resource.source_type}</div>
          <Caret className='ResourceHeader__arrow' />
        </div>}
        <h1 className='ResourceHeader__title'>{this.state.resource.title}</h1>
      </div>
      <div>
        {this.state.resource.source_type_key && <a className='ResourceHeader__link ResourceHeader__link--details' href={`/resources/external/${this.state.resource.source_type_key}/${this.state.resource.external_id}`}>Resource details</a>}
        <a className='ResourceHeader__link ResourceHeader__link--close' href='/'><span>Remove this filter </span><Close /></a>
      </div>
    </header>

    return (
      <div>{this.state.resource && this.state.resource.id && resource}</div>
    )
  }
}

ResourceHeader.propTypes = {
  resourceId: PropTypes.string
}

export default ResourceHeader



// WEBPACK FOOTER //
// ./components/search/ResourceHeader.js